import { Grid, Button, DialogActions, DialogContent } from '@mui/material';
import { DialogCustom, DialogTitleCustom } from '@tap/mui-ui';
import { ICancelDialogResult, IDialogProps } from '../Dialog';

/*
*   Диалог: Добавить зону
*/

export type TransactionInfoDialogInputProps = {
    transactionId: string,
}

export default function TransactionInfoDialog({
    data,
    isOpen,
    handleClose,
}: IDialogProps<TransactionInfoDialogInputProps, ICancelDialogResult>) {
    const handleCancel = (): void => {
        handleClose({ isCancel: true });
    }

    return (
        <DialogCustom
            handleClose={handleCancel}
            open={isOpen}
            dialogMaxWidth={'700px'}
        >

            <DialogTitleCustom primaryText={`Транзакция ${data.transactionId}`} />

            <DialogContent>
                TODO
            </DialogContent>

            <DialogActions >
                <Grid container justifyContent='flex-end'>

                    <Button
                        disableElevation
                        type='button'
                        variant='text'
                        color='primary'
                        onClick={handleCancel}
                    >
                        Закрыть
                    </Button>

                </Grid>
            </DialogActions>

        </DialogCustom >
    );
}
